/* eslint-disable @typescript-eslint/no-empty-function */
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PRODUCTS_OF_PROVIDER_TTL_ES } from '../../../products-of-provider.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { ProductsOfProviderService } from '../../../products-of-provider.service';
import { IProductUnregulated } from 'src/app/pages/gestion/products-unregulated/product-unregulated.interface';
import { IRegulatedProduct } from 'src/app/pages/gestion/regulated-products/regulated-product.interface';

const TYPE_PRODUCT = {
  REGULATED: 1,
  UNREGULATED: 2
};

@Component({
  selector: 'pg-products-of-provider-create',
  templateUrl: './products-of-provider-create.component.html'
})
export class ProductsOfProviderCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  PRODUCTS_TYPES_NAMES_FOR_DROPDOWN = [
    { label: 'REGULADOS', value: 'REGULATED' },
    { label: 'NO REGULADOS', value: 'UNREGULATED' }
  ];

  select = {
    unitMeasure: {
      type: 'single',
      openDialog: false,
      id: null
    },
    provider: {
      type: 'single',
      openDialog: false,
      id: null
    },
    product: {
      type: 'single',
      REGULATED: {
        openDialog: false,
        id: null
      },
      UNREGULATED: {
        openDialog: false,
        id: null
      },
      data: null
    }
  };

  constructor(
    private fb: FormBuilder,
    private productsOfProviderService: ProductsOfProviderService
  ) {
    super(PRODUCTS_OF_PROVIDER_TTL_ES, productsOfProviderService);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      code: [
        null,
        [Validators.minLength(3), Validators.maxLength(10)]
      ],
      description: [
        null,
        [Validators.required, Validators.minLength(5), Validators.maxLength(50)]
      ],
      unitMeasure: [
        { value: 'Seleccionar', disabled: true },
        [Validators.required]
      ],
      provider: [
        { value: 'Seleccionar', disabled: true },
        [Validators.required]
      ],
      productType: [null, [Validators.required]],
      product: [null, [Validators.required]]
    });
  }

  onSubmit() {
    if (this.fg.valid) {
      const itemParsed = this.parseData(this.fg.value);
      this.createItem$(itemParsed);
    }
  }

  parseData(form) {
    const payload = {
      productId: this.select.product[form.productType].id,
      typeProductId: TYPE_PRODUCT[form.productType],
      code: form.code,
      description: form.description,
      providerId: this.select.provider.id,
      unitMeasureId: this.select.unitMeasure.id
    };
    if(payload.code === null || payload.code === '' ) delete payload.code;
    return payload;
  }

  onSelectedUnitMeasure(row) {
    if (row) {
      this.fg.get('unitMeasure').setValue(row.description);
      this.select.unitMeasure.id = row.id;
    }
    this.select.unitMeasure.openDialog = false;
  }

  onSelectedProvider(row) {
    if (row) {
      this.fg.get('provider').setValue(row.name);
      this.select.provider.id = row.id;
    }
    this.select.provider.openDialog = false;
  }

  onSelectedRegulatedProduct(row: IRegulatedProduct) {
    if (row) {
      this.select.product.data = row;
      this.fg.controls.product.setValue(`${row.code} - ${row.name}`);
      this.fg.get('description').setValue(row.name);
      this.select.product.REGULATED.id = row.id;
    }
    this.select.product.REGULATED.openDialog = false;
  }

  onSelectedUnregulatedProduct(row: IProductUnregulated) {
    if (row) {
      this.select.product.data = row;
      this.fg.controls.product.setValue(`${row.code} - ${row.name}`);
      this.fg.get('description').setValue(row.name);
      this.select.product.UNREGULATED.id = row.id;
    }
    this.select.product.UNREGULATED.openDialog = false;
  }

  openDialogByProductType() {
    this.select.product[this.fg.get('productType').value].openDialog = true;
  }

  onDropdownChanged() {
    this.fg.get('product').setValue(null);
  }
}
